import { useDocumentTitle } from '../../lib/title';
import { CharacterMaker } from './CharacterMaker';

/**
 * Building your character.
 *
 * ## Why it is a page as well as a drawer
 *
 * It is reached by pressing your own character on your own profile, which opens
 * it over that profile - and that is the way anybody will ever find it. But a
 * drawer is a route, and a route has to answer a cold request: a bookmark, a
 * reload, a link pasted to somebody. Without this the address would fall
 * through to `:username` and tell them nobody goes by @character.
 *
 * ## Not in settings
 *
 * Settings is how you appear to other people - a picture, a name, a bio. This
 * is who you are in a room, and it is worth seeing against the profile it will
 * be standing on rather than buried in a column of form fields.
 */
export function CharacterPage({ inDrawer = false }: { inDrawer?: boolean }) {
  useDocumentTitle('Your character');

  return (
    <div
      className={
        inDrawer
          ? 'flex flex-col gap-5 p-5'
          : // Wider than the usual reading measure: this is a preview beside two
            // columns of controls, and at `max-w-2xl` the columns collapse into
            // the stack the steppers exist to avoid.
            'mx-auto flex max-w-4xl flex-col gap-6 px-6 py-10'
      }
    >
      {/* The drawer's own header already says what this is. */}
      {!inDrawer && (
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Your character</h1>
          <p className="mt-1 text-sm text-soft">Who you are in a room.</p>
        </div>
      )}

      <CharacterMaker />
    </div>
  );
}
